export const Pin = (props: any) => <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.39972 2H13.5997M12 8.66667L7.99998 4.66667M7.99998 4.66667L3.99998 8.66667M7.99998 4.66667L7.99972 14.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
